import React, { useEffect, useMemo, useRef, useState } from 'react';
import { connect } from 'react-redux';
import Checkbox from '@material-ui/core/Checkbox';
import { ErrorInfo, isErrorInfo } from '../../../shared/interfaces/error-info.interface';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import { withStyles } from '@material-ui/core/styles';
import { UnitTypeUiModel } from '../../../shared/ui-models/unit-type.ui-model';
import { ChooseUnitType } from './components/choose-unit-type-modal/choose-unit-type.component';
import { ChooseAppt, PromoCodeOption } from './components/choose-appt/choose-appt.component';
import {
  BookAvailabilityResponseModel,
  BookOfferResponseModel
} from '../../../shared/ui-models/book.ui-model';
import {
  getBookAvailability,
  getBookOffer,
  createReservation,
  creatBlockDates
} from '../../shared/services/data.service';
import { getAllBrokers } from '../../../shared/services/data/broker.data';
import { PaymentDetails } from './components/payment-details/payment-details.component';
import { AddGuest } from './components/add-guest/add-guest.component';
import Select, { ValueType } from 'react-select';
import Button, {
  ButtonSize,
  ButtonType
} from '../../../shared/components/core-ui/button/button.component';
import { CreateReservationRequestModel } from '../../../shared/models/reservation.model';
import moment from 'moment';
import { CreateBlockDatesModel } from '../../../shared/models/block-dates.model';
import { TextArea } from '../../../shared/components/core-ui/text-area/text-area.component';
import {
  InputText,
  InputTextType
} from '../../../shared/components/core-ui/input-text/input-text.component';
import { ReservationType } from '../../../shared/enums/reservation-type';
import { ReservationMode } from '../../../shared/enums/reservation-mode.enum';
import { UnitTypeGroupUiModel } from '../../../shared/ui-models/unit-type-group.ui-model';
import { ReservationChannel } from '../../../shared/enums/reservation-channel.enum';
import ReCAPTCHA from 'react-google-recaptcha';
import { GOOGLE_CAPTCHA_KEY } from '../../../shared/config/routes-config';
import { ReservationSource } from '../../../shared/enums/reservation-souce.enum';
import {
  AssignableReservationSource,
  getAssignableSourceOptions,
  reservationChannelOptionsBySource,
  ReservationSourceOption,
  resolveAttributionChannels
} from '../../../shared/services/helpers/reservation-source-channel.helper';
import { ReservationTypeOfStay } from '../../../shared/enums/reservation-type-of-stay.enum';
import { PaymentGateway } from '../../../shared/enums/payment-gateway.enum';
import {
  AdType,
  MarketingChannel,
  MessagingChannel,
  marketingChannelOptions,
  messagingChannelOptions
} from '../../../shared/interfaces/attribution.interface';

import Modal from '../../../ui/Model';
import { birdToast } from '../../../shared/components/core-ui/toast';
import { CompanyUiModel } from '../../../shared/ui-models/company.ui-model';
import { getAllCompanies } from '../../../CompanyModule/shared/services/data.service';
import { BrokerUiModel } from '../../../shared/ui-models/broker.ui-model';
import { UserRole } from '../../../shared/enums/user-role.enum';
import { hasRole } from '../../../shared/services/helpers/auth-helper/auth-helper.service';
import api from '../../../shared/services/utils/api/api.service';
import { getSalesPersons } from '../../../SalesPersonsModule/data.service';
import { UserUIModel } from '../../../shared/ui-models/user.ui-model';
import { RootState } from '../../../shared/redux/reducers';

const captchaKEy = GOOGLE_CAPTCHA_KEY;
const blockDateTypeOptions = [
  { value: 'isOwnerStay', label: 'Owner stay' },
  { value: 'isMaintenance', label: 'Maintenance' },
  { value: 'other', label: 'Other' }
] as const;
type BlockDateType = (typeof blockDateTypeOptions)[number]['value'];
const ownerStayDescription = 'Owners Visit';
const maintenanceDescription = 'blocked for Maintenance';

// The marketing half of "where did this booking come from". A reservation made
// from a booking inherits these server-side; one created here has no booking to
// inherit from, so an admin taking a call or a walk-in answers them by hand.
//
// Both are shown only for a CX source -- see `isCxSource` -- because CX is the
// team that takes the call and can actually ask. While shown, both stay
// optional: `unknown` is a real answer -- we asked and could not tell -- which
// is not the same as leaving the field alone, so both are reachable: pick
// `Unknown`, or clear the field.
//
// `adType` used to be a third picker here and is not one any more: nothing
// created on this form comes from an ad, so it is sent as `unknown` outright.
type PromotionResponseItem = {
  name?: string;
};

type BrokerOption = {
  value: number;
  label: string;
};

type SalesPersonOption = {
  value: string;
  label: string;
  salesPerson: UserUIModel;
};

export interface ReservationsCreateModalProps {
  reservationType: string;
  eventHandlers: {
    closeHandler: () => void;
  };
  openModal: boolean;
  onClose: () => void;
  unitTypeGroupsList: UnitTypeGroupUiModel[];
  allProjects: {
    label: string;
    value: string;
    areaId: string;
  }[];
  allAreas: {
    value: string;
    label: string;
    areaId: string;
  }[];
}

// No app-wide MUI theme, so `color="primary"` would be MUI's default blue. The
// same green the checkboxes on this form use.
const GreenSwitch = withStyles({
  switchBase: {
    '&$checked': { color: '#237c58' },
    '&$checked + $track': { backgroundColor: '#237c58' }
  },
  checked: {},
  track: {}
})(Switch);

export const ReservationsCreateContainer: React.FC<ReservationsCreateModalProps> = ({
  reservationType,
  eventHandlers,
  openModal,
  onClose,
  unitTypeGroupsList,
  allProjects,
  allAreas
}) => {
  // const [unitType, setUnitType] = useState<UnitTypeUiModel[]>([]);
  const [selectedUnitType, SetSelectedUniType] = useState<UnitTypeUiModel>();
  const [selectedDates, setSelectedDates] = useState<Date[]>();
  const [skipEmail, setSkipEmail] = useState<boolean>(false);
  const [isComplimentary, setIsComplimentary] = useState<boolean>(false);
  const [isRelatedReservation, setIsRelatedReservation] = useState<boolean>(false);
  const [relatedReservationId, setRelatedReservationId] = useState<string>('');
  // const [skipPaymentEmail, setSkipPaymentEmail] = useState<boolean>(false);
  const [description, setDescription] = useState<string>('');
  const [blockDateType, setBlockDateType] = useState<BlockDateType>('other');
  const [proceedGuestStep, setProceedGuestStep] = useState<boolean>();
  const [bookAvailability, setBookAvailability] = useState<Date[]>([]);
  const [bookoffer, setBookoffer] = useState<BookOfferResponseModel>();
  const [selectedRoom, setSelectedRoom] = useState<string>();
  const [selectedRoomName, setSelectedRoomName] = useState<string>();
  const [selectedChannel, setSelectedChannel] = useState<ReservationChannel>(
    ReservationChannel.BIRDNEST
  );
  const [source, setSource] = useState<AssignableReservationSource>(ReservationSource.CX);
  const [marketingChannel, setMarketingChannel] = useState<MarketingChannel>();
  const [messagingChannel, setMessagingChannel] = useState<MessagingChannel>();
  const [typeOfStay, setTypeOfStay] = useState<ReservationTypeOfStay>();
  // BROKER narrows this to the two sources that can credit a broker; every
  // other segment gets the full list.
  const sourceOptions = useMemo(() => getAssignableSourceOptions(typeOfStay), [typeOfStay]);
  // Marketing and messaging are CX questions: that team takes the call and asks
  // the guest. No other source has anyone to ask, so the two pickers are hidden
  // and the answer is recorded as such. Derived from `source` rather than reset
  // when it changes -- `source` moves from two places on this form, its own
  // picker and the broker narrowing on Segment, and a reset would have to be
  // duplicated in both.
  const isCxSource = source === ReservationSource.CX;
  const [companyId, setCompanyId] = useState<string>('');
  const [companiesList, setCompaniesList] = useState<CompanyUiModel[]>([]);
  const [brokersList, setBrokersList] = useState<BrokerUiModel[]>([]);
  const [brokerId, setBrokerId] = useState<number>();
  const [isBrokersLoading, setIsBrokersLoading] = useState<boolean>(false);
  const [promotionOptions, setPromotionOptions] = useState<PromoCodeOption[]>([]);
  const [promoCode, setPromoCode] = useState<string>('');
  const [isPromotionsLoading, setIsPromotionsLoading] = useState<boolean>(false);
  const [salesPerson, setSalesPerson] = useState<UserUIModel | null>(null);
  const [salesPersons, setSalesPersons] = useState<UserUIModel[]>([]);
  const [isSalesPersonsLoading, setIsSalesPersonsLoading] = useState<boolean>(false);
  const [guestDetails, setGuestDetails] = useState<{
    name: string;
    phoneNumber: string;
    email: string;
    gender: string;
    id: string;
  }>();
  const [canProceedAddGuest, setCanProceedAddGuest] = useState<boolean>(false);
  const addGuestProceedRef = useRef<null | (() => void)>(null);

  const [discountAmount, setDiscountAmount] = useState<number>();
  const [overRideUnitPrice, setOverRideUnitPrice] = useState<number>();
  const [discountFees, setDiscountFees] = useState<string[]>();
  const promotionsLoadedRef = useRef<boolean>(false);
  const recaptchaRef = useRef<ReCAPTCHA>(null);
  const [stepIndex, setStepIndex] = useState<number>(0);

  // Built once so the options and the selected value share one identity, and
  // narrowed to brokers that actually have an id -- `BrokerUiModel.id` is
  // optional and an option without a value cannot be selected anyway.
  const brokerOptions: BrokerOption[] = brokersList
    .filter((broker): broker is BrokerUiModel & { id: number } => typeof broker.id === 'number')
    .map((broker) => ({ value: broker.id, label: broker.name || `Broker ${broker.id}` }));

  const isCreateBlockDates = reservationType === ReservationType.BLOCK_DATES;
  const isCreateReservation = reservationType === ReservationType.NORMAL_RESERVATION;
  const isSuperAdmin = hasRole([UserRole.SUPER_ADMIN]);

  const handleSkipEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setSkipEmail(event.target.checked);
  };

  // const handleSkipPaymentEmailChange = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   setSkipPaymentEmail(event.target.checked);
  // };

  useEffect(() => {
    getAllCompanies().then((response: CompanyUiModel[] | ErrorInfo) => {
      if (!isErrorInfo(response)) {
        setCompaniesList(response);
      }
    });

    setIsBrokersLoading(true);
    getAllBrokers()
      .then((response: BrokerUiModel[] | ErrorInfo) => {
        setBrokersList(isErrorInfo(response) ? [] : response);
      })
      .finally(() => {
        setIsBrokersLoading(false);
      });

    setIsSalesPersonsLoading(true);
    getSalesPersons()
      .then((response: UserUIModel[] | ErrorInfo) => {
        if (!isErrorInfo(response)) {
          setSalesPersons(response);
        } else {
          setSalesPersons([]);
        }
      })
      .finally(() => {
        setIsSalesPersonsLoading(false);
      });
  }, []);

  async function loadPromotions() {
    if (!isSuperAdmin || isPromotionsLoading || promotionsLoadedRef.current) return;

    setIsPromotionsLoading(true);

    try {
      const response = await api.getPromotions();
      if (!response.ok) return;

      const promotions = (response.data as any)?.data;
      if (!Array.isArray(promotions)) return;

      const options = (promotions as PromotionResponseItem[])
        .map((promotion) => promotion.name?.trim())
        .filter((name): name is string => Boolean(name))
        .map((name) => ({ value: name, label: name }));

      setPromotionOptions(options);
      promotionsLoadedRef.current = true;
    } finally {
      setIsPromotionsLoading(false);
    }
  }

  function getAvailability(unitTypeId: string) {
    return getBookAvailability(unitTypeId).then((resp) => {
      if (!isErrorInfo(resp)) {
        const bookAvailabilityResponse = resp as BookAvailabilityResponseModel[];
        let availabeDates: Date[] = [];
        bookAvailabilityResponse.forEach((availObj) => {
          const dates = getDaysArray(availObj.from, availObj.to);
          availabeDates = [...availabeDates, ...dates];
        });
        setBookAvailability(availabeDates);
      }
    });
  }

  function handleBlockDateCreation() {
    const blockDates: CreateBlockDatesModel = {
      unitTypeId: Number(selectedUnitType?.id),
      roomId: selectedRoom || '',
      roomName: selectedRoomName || '',
      fromDate: (selectedDates && moment(selectedDates[0]).format('DD/MM/YYYY')) || '',
      toDate: (selectedDates && moment(selectedDates[1]).format('DD/MM/YYYY')) || '',
      description:
        blockDateType === 'isOwnerStay'
          ? ownerStayDescription
          : blockDateType === 'isMaintenance'
            ? maintenanceDescription
            : description,
      ...(blockDateType === 'isOwnerStay' && { isOwnerStay: true }),
      ...(blockDateType === 'isMaintenance' && { isMaintenance: true })
    };
    const promise = creatBlockDates(blockDates).then((response) => {
      if (!isErrorInfo(response)) {
        eventHandlers.closeHandler();
      }
    });
    birdToast.promise(promise, {
      errorFailedMessage: 'Failed to block dates',
      successMessage: 'Dates blocked successfully',
      loadingMessage: 'Blocking dates...',
      errorPermissionMessage: 'You do not have permission to block dates'
    });
  }

  const handleCreateReservation = async () => {
    if (isCreateReservation) {
      const reservations: CreateReservationRequestModel = {
        primaryGuestName: guestDetails?.name || '',
        phoneNumber: guestDetails?.phoneNumber || '',
        gender: guestDetails?.gender || '',
        email: guestDetails?.email || '',
        skipEmail,
        // skipPaymentEmail,
        channel: selectedChannel,
        source,
        // Spread rather than set to undefined: an untouched field must not reach
        // the API at all. `unknown` is an answer someone gave, and a reservation
        // that arrives carrying it should mean exactly that.
        // Off CX this records `unknown` / `none` -- nobody asked, and that is
        // the answer. MessagingChannel has no `unknown` member and its enum is
        // enforced on four collections server-side, so `none` is the value that
        // carries the meaning today. Shared with the edit modal so both screens
        // answer this the same way.
        ...resolveAttributionChannels(source, { marketingChannel, messagingChannel }),
        // Always `unknown`, with no picker for it. A reservation created here
        // was taken by hand -- a call, a walk-in, a broker -- so there is no ad
        // to attribute it to, and that is an answer rather than a gap. Hence
        // sent outright instead of spread in like the two above.
        adType: AdType.UNKNOWN,
        typeOfStay: typeOfStay ? typeOfStay : undefined,
        companyId: companyId || undefined,
        // Only the id is sent. server.service.property resolves the name from
        // it and stores both, so a reservation can never name one broker while
        // pointing at another.
        brokerId: typeOfStay === ReservationTypeOfStay.BROKER ? brokerId : undefined,
        // ...(selectedUnitType?.propertyId === GEIDEA_PROJECT_ID && {
        //   paymentGateway: PaymentGateway.GEIDEA
        // }),
        // A template literal is always truthy, so the `|| ''` that used to sit
        // here never fired -- an unpicked sales person was sent as the literal
        // string 'undefined (undefined)'. This field is how a broker booking is
        // credited now that `channel` no longer names brokers, so a junk value
        // in it is a payout that cannot be traced.
        salesPerson: salesPerson ? `${salesPerson.email} (${salesPerson.name})` : '',
        relatedReservationId: isRelatedReservation
          ? Number(relatedReservationId.trim())
          : undefined,
        isComplimentary,
        unitTypeId: Number(selectedUnitType?.id),
        roomId: selectedRoom || '',
        recurringPayment: bookoffer?.recurringPayment,
        oneTimePayment: bookoffer?.oneTimePayment,
        rateCard: bookoffer?.rateCard,
        discountAmount,
        discountFees,
        promoCodeUsed: bookoffer?.promoCodeUsed,
        checkInDate:
          selectedDates && selectedDates[0] ? moment(selectedDates[0]).format('DD/MM/YYYY') : '',
        checkOutDate:
          selectedDates && selectedDates[1] ? moment(selectedDates[1]).format('DD/MM/YYYY') : ''
      };
      if (guestDetails?.id !== '') {
        reservations['userId'] = guestDetails?.id || '';
      }
      const rawToken = await recaptchaRef?.current?.executeAsync();
      const token: string | undefined = rawToken || undefined;
      const promise = createReservation({ ...reservations, token }).then((response) => {
        if (!isErrorInfo(response)) {
          eventHandlers.closeHandler();
        } else {
          throw response;
        }
      });
      birdToast.promise(promise, {
        errorFailedMessage: 'Failed to create reservation',
        successMessage: 'Reservation created successfully',
        loadingMessage: 'Creating reservation...',
        errorPermissionMessage: 'You do not have permission to create reservation'
      });
    }
  };
  return (
    <Modal
      isOpen={openModal}
      onClose={() => {
        onClose();
      }}
      containerClassName="lg:h-fit lg:max-h-[85vh] lg:w-[900px]"
      contentClassName="pt-2"
      headerContent={
        <div>
          {isCreateReservation && (
            <div className="text-2xl font-gilroy-bold">Create Reservation</div>
          )}
          {isCreateBlockDates && <div className="text-2xl font-gilroy-bold">Block Dates</div>}
        </div>
      }
      footerContent={
        <div className="flex items-center justify-between w-full gap-3">
          {/* Back Button */}
          <Button
            onClick={() => {
              if (proceedGuestStep) {
                setProceedGuestStep(false);
                setStepIndex(1);
                return;
              }

              if (!selectedUnitType) return;

              SetSelectedUniType(undefined);
              setStepIndex(0);
            }}
            disabled={!selectedUnitType}
            size={ButtonSize.medium}
            type={ButtonType.primaryInverted}
          >
            Back
          </Button>

          {/* Right Side Actions */}
          <div className="flex items-center gap-3">
            {/* Add Guest Step - Show proceed controls */}
            {proceedGuestStep && !guestDetails ? (
              <>
                <Button
                  onClick={eventHandlers.closeHandler}
                  tracking={{ event: 'record_edit_cancelled', entity: 'guest', method: 'close' }}
                  size={ButtonSize.medium}
                  type={ButtonType.danger}
                >
                  Cancel
                </Button>
                <Button
                  disabled={!canProceedAddGuest}
                  onClick={() => addGuestProceedRef.current?.()}
                  tracking={{
                    event: 'record_saved',
                    entity: 'guest',
                    action: 'update',
                    outcome: 'success'
                  }}
                  size={ButtonSize.medium}
                >
                  Proceed
                </Button>
              </>
            ) : (
              <>
                {/* Cancel Button */}
                <Button
                  onClick={eventHandlers.closeHandler}
                  tracking={{
                    event: 'record_edit_cancelled',
                    entity: 'appointment',
                    method: 'close'
                  }}
                  size={ButtonSize.medium}
                  type={ButtonType.danger}
                >
                  Cancel
                </Button>

                {/* Primary Action Button */}
                {isCreateBlockDates ? (
                  <Button
                    disabled={
                      !Array.isArray(selectedDates) ||
                      !selectedDates.length ||
                      !selectedRoom ||
                      !selectedRoomName ||
                      (blockDateType === 'other' && !description)
                    }
                    onClick={handleBlockDateCreation}
                    tracking={{
                      event: 'record_saved',
                      entity: 'appointment',
                      action: 'update',
                      outcome: 'success'
                    }}
                    size={ButtonSize.medium}
                  >
                    Block Dates
                  </Button>
                ) : proceedGuestStep ? (
                  <Button
                    disabled={
                      !selectedRoom ||
                      !typeOfStay ||
                      (typeOfStay === ReservationTypeOfStay.CORPORATES && !companyId) ||
                      (typeOfStay === ReservationTypeOfStay.BROKER && !brokerId) ||
                      (isRelatedReservation && !relatedReservationId.trim())
                      // ||(source === ReservationSource.OFFLINE_SALES && !salesPerson)
                    }
                    onClick={handleCreateReservation}
                    tracking={{
                      event: 'record_saved',
                      entity: 'appointment',
                      action: 'update',
                      outcome: 'success'
                    }}
                    size={ButtonSize.medium}
                  >
                    Create Reservation
                  </Button>
                ) : (
                  <Button
                    disabled={!selectedUnitType || !selectedDates?.length}
                    onClick={() => {
                      if (isCreateReservation) {
                        setProceedGuestStep(true);
                        setGuestDetails(undefined);
                        setCanProceedAddGuest(false);
                        addGuestProceedRef.current = null;
                        setStepIndex(2);
                      }
                    }}
                    tracking={{
                      event: 'record_saved',
                      entity: 'appointment',
                      action: 'update',
                      outcome: 'success'
                    }}
                    size={ButtonSize.medium}
                  >
                    Next
                  </Button>
                )}
              </>
            )}
          </div>
        </div>
      }
    >
      <div className="flex flex-col w-full">
        <div className="flex items-center justify-center text-base w-full space-x-4 mb-1.5">
          {(isCreateReservation
            ? ['Choose Unit', 'Choose Dates', 'Guest & Options']
            : ['Choose Unit', 'Block Dates']
          ).map((label, idx) => (
            <div key={label} className="flex items-center">
              <div
                className={`w-8 h-8 rounded-full flex items-center justify-center mr-2 ${
                  stepIndex >= idx ? 'bg-primary-500 text-white' : 'bg-gray-200 text-gray-700'
                }`}
              >
                {idx + 1}
              </div>
              <div
                className={`${stepIndex >= idx ? 'text-primary-600 font-medium' : 'text-gray-600'}`}
              >
                {label}
              </div>
              {((idx !== 2 && isCreateReservation) || (idx !== 1 && !isCreateReservation)) && (
                <div
                  className={`mx-3 w-8 h-px ${stepIndex > idx ? 'bg-primary-500' : 'bg-gray-300'}`}
                />
              )}
            </div>
          ))}
        </div>
        <div className="w-full overflow-auto pb-24">
          <div className={!selectedUnitType ? 'block' : 'hidden'}>
            <ChooseUnitType
              data={{
                allAreas: allAreas,
                allProjects: allProjects,
                unitTypeGroups: unitTypeGroupsList
              }}
              eventHandlers={{
                selectedUnitType: (selectedUnit) => {
                  getAvailability(selectedUnit.id || '').then(() => {
                    SetSelectedUniType(selectedUnit);
                    setStepIndex(1);
                  });
                }
              }}
            />
          </div>

          <div className={selectedUnitType ? 'flex gap-6' : 'hidden'}>
            <div>
              {selectedUnitType && !proceedGuestStep && (
                <>
                  {selectedUnitType &&
                  selectedUnitType.ratePlans &&
                  selectedUnitType.ratePlans.length ? (
                    <div className="mb-4">
                      <div className="mb-3">
                        <div className="flex space-x-4 items-start">
                          <div className="border p-3 rounded">
                            <div className="text-sm text-gray-500">
                              <div className="text-base font-medium">
                                {selectedUnitType.reservationMode === 'monthly' ? '1' : 'Base'}
                              </div>
                              <div className="text-gray-600">
                                {selectedUnitType.reservationMode === 'monthly' ? 'month' : 'Rate'}
                              </div>
                            </div>
                            <div className="mt-2 text-lg">
                              EGP <b className="text-xl font-bold">{selectedUnitType.unitPrice}</b>
                            </div>
                            <div className="text-sm text-gray-500">
                              {selectedUnitType.reservationMode === 'monthly'
                                ? 'Monthly'
                                : 'per Night'}
                            </div>
                          </div>
                          {selectedUnitType.ratePlans.map((ratePlan) => (
                            <div className="border p-3 rounded" key={ratePlan.name}>
                              <div className="text-sm text-red-600">{`${ratePlan.amount}% off`}</div>
                              <div className="text-base font-medium">{ratePlan.name}</div>
                              <div className="mt-2 text-lg">
                                EGP{' '}
                                <b className="text-xl font-bold">
                                  {selectedUnitType
                                    ? parseInt(
                                        (
                                          (selectedUnitType.unitPrice as number) *
                                          (1 - ratePlan.amount / 100)
                                        ).toString()
                                      )
                                    : 0}
                                </b>
                              </div>
                              <div className="text-sm text-gray-500">
                                {selectedUnitType.reservationMode === 'monthly'
                                  ? 'Monthly'
                                  : 'per Night'}
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                    </div>
                  ) : (
                    ''
                  )}
                  <ChooseAppt
                    data={{
                      disbaleDate: bookAvailability,
                      selectedUnitType: selectedUnitType,
                      basePrice:
                        selectedUnitType.reservationMode === ReservationMode.DAILY
                          ? selectedUnitType.unitPrice
                          : undefined,
                      customPrices:
                        selectedUnitType.reservationMode === ReservationMode.DAILY
                          ? selectedUnitType.customPrices
                          : undefined,
                      reservationType: reservationType as ReservationType,
                      overRideUnitPrice: overRideUnitPrice,
                      promotion: isSuperAdmin
                        ? {
                            promoCode,
                            options: promotionOptions,
                            isLoading: isPromotionsLoading
                          }
                        : undefined
                    }}
                    eventHandlers={{
                      setDatesAndDiscountFees: (dates, discountAmount, discountFees) => {
                        if (Array.isArray(dates) && dates.length === 2) {
                          setSelectedDates(dates);
                          setDiscountAmount(discountAmount);
                          setDiscountFees(discountFees);
                          getBookOffer(
                            selectedUnitType.id || '',
                            moment(dates[0]).format('DD/MM/YYYY'),
                            moment(dates[1]).format('DD/MM/YYYY'),
                            discountAmount,
                            discountFees,
                            overRideUnitPrice,
                            promoCode || undefined
                          ).then((res) => {
                            if (!isErrorInfo(res)) {
                              setBookoffer(res as BookOfferResponseModel);
                            }
                          });
                        }
                      },
                      onOverRideUnitPrice: (overRidePrice) => {
                        setOverRideUnitPrice(overRidePrice);
                        getBookOffer(
                          selectedUnitType.id || '',
                          moment(selectedDates ? selectedDates[0] : new Date()).format(
                            'DD/MM/YYYY'
                          ),
                          moment(selectedDates ? selectedDates[1] : new Date()).format(
                            'DD/MM/YYYY'
                          ),
                          discountAmount,
                          discountFees,
                          overRidePrice,
                          promoCode || undefined
                        ).then((res) => {
                          if (!isErrorInfo(res)) {
                            setBookoffer(res as BookOfferResponseModel);
                          }
                        });
                      },
                      onClearOverRideUnitPrice: () => {
                        setOverRideUnitPrice(undefined);
                        getBookOffer(
                          selectedUnitType.id || '',
                          moment(selectedDates ? selectedDates[0] : new Date()).format(
                            'DD/MM/YYYY'
                          ),
                          moment(selectedDates ? selectedDates[1] : new Date()).format(
                            'DD/MM/YYYY'
                          ),
                          discountAmount,
                          discountFees,
                          undefined,
                          promoCode || undefined
                        ).then((res) => {
                          if (!isErrorInfo(res)) {
                            setBookoffer(res as BookOfferResponseModel);
                          }
                        });
                      },
                      onPromoCodeMenuOpen: loadPromotions,
                      onApplyPromoCode: (nextPromoCode) => {
                        setPromoCode(nextPromoCode);
                        if (!selectedDates || selectedDates.length !== 2) return;

                        getBookOffer(
                          selectedUnitType.id || '',
                          moment(selectedDates[0]).format('DD/MM/YYYY'),
                          moment(selectedDates[1]).format('DD/MM/YYYY'),
                          discountAmount,
                          discountFees,
                          overRideUnitPrice,
                          nextPromoCode || undefined
                        ).then((res) => {
                          if (!isErrorInfo(res)) {
                            setBookoffer(res as BookOfferResponseModel);
                          }
                        });
                      },
                      proceedApptNextStep: (next: boolean) => {
                        if (isCreateReservation) {
                          setProceedGuestStep(next);
                          setStepIndex(2);
                        }
                      },
                      cancelHandler: eventHandlers.closeHandler
                    }}
                    blockDataComponent={
                      <>
                        <div className="mt-2">
                          Choose room
                          <Select
                            className="mb-3"
                            options={bookoffer?.availableRooms.map((room) => ({
                              label: room.shortName,
                              value: room.unitId
                            }))}
                            onChange={(
                              value: ValueType<{ value: string | undefined; label: string }, false>
                            ) => {
                              setSelectedRoom(value?.value);
                              setSelectedRoomName(value?.label);
                            }}
                          />
                          Choose type
                          <Select
                            className="mb-3"
                            options={blockDateTypeOptions.map((option) => ({
                              value: option.value,
                              label: option.label
                            }))}
                            value={blockDateTypeOptions.find(
                              (option) => option.value === blockDateType
                            )}
                            onChange={(
                              value: ValueType<{ value: BlockDateType; label: string }, false>
                            ) => {
                              const nextType = value?.value || 'other';
                              setBlockDateType(nextType);
                              if (nextType === 'isOwnerStay') {
                                setDescription(ownerStayDescription);
                              } else if (nextType === 'isMaintenance') {
                                setDescription(maintenanceDescription);
                              } else {
                                setDescription('');
                              }
                            }}
                          />
                          {blockDateType === 'other' && (
                            <div className="">
                              <span className="block">Comment</span>
                              <TextArea
                                data={{
                                  value: description,
                                  placeholder: 'Add your comment'
                                }}
                                config={{
                                  autoFocus: true,
                                  maxRows: 5,
                                  className: 'w-full'
                                }}
                                eventHandlers={{
                                  onChangeHandler: (value: string) => {
                                    setDescription(value);
                                  }
                                }}
                              />
                            </div>
                          )}
                        </div>
                      </>
                    }
                  />
                </>
              )}
              {proceedGuestStep && !guestDetails && (
                <div>
                  <AddGuest
                    eventHandlers={{
                      addGuestHandler: (guest) => {
                        setGuestDetails(guest);
                      },
                      closeHandler: () => {
                        eventHandlers.closeHandler();
                      },
                      canProceedChange: (nextCanProceed) => {
                        setCanProceedAddGuest(nextCanProceed);
                      },
                      setProceedHandler: (handler) => {
                        addGuestProceedRef.current = handler;
                      }
                    }}
                  />
                </div>
              )}

              {guestDetails && (
                <div>
                  Choose room
                  <Select
                    className="mb-3"
                    options={bookoffer?.availableRooms.map((room) => ({
                      label: room.shortName,
                      value: room.unitId
                    }))}
                    onChange={(
                      value: ValueType<{ value: string | undefined; label: string }, false>
                    ) => {
                      setSelectedRoom(value?.value);
                      setSelectedRoomName(value?.label);
                    }}
                  />
                  {isCreateReservation && (
                    <>
                      Segment
                      <Select
                        className="mb-3"
                        options={Object.values(ReservationTypeOfStay)?.map((s) => ({
                          value: s,
                          label: s.replaceAll('_', ' ')?.toUpperCase()
                        }))}
                        onChange={(
                          value: ValueType<{ value: string | undefined; label: string }, false>
                        ) => {
                          const nextType =
                            (value?.value as ReservationTypeOfStay) ||
                            ReservationTypeOfStay.CORPORATES;
                          setTypeOfStay(nextType);
                          if (nextType !== ReservationTypeOfStay.CORPORATES) {
                            setCompanyId('');
                          }
                          // Same reason as the company reset above: a broker
                          // left over from a previous selection would credit a
                          // commission on a booking that is no longer a broker
                          // booking at all.
                          if (nextType !== ReservationTypeOfStay.BROKER) {
                            setBrokerId(undefined);
                          }
                          // Segment sits above Source on this form, so
                          // narrowing the list is not enough on its own -- a
                          // source picked before the segment was set has to be
                          // pulled back inside it, or the form would submit a
                          // value its own picker no longer offers.
                          const allowedSources = getAssignableSourceOptions(nextType);
                          if (!allowedSources.some((option) => option.value === source)) {
                            const nextSource = allowedSources[0]
                              .value as AssignableReservationSource;
                            setSource(nextSource);
                            setSelectedChannel(
                              reservationChannelOptionsBySource[nextSource][0].value
                            );
                          }
                        }}
                      />
                      Select Source
                      <Select
                        className="mb-3"
                        options={sourceOptions}
                        value={sourceOptions.find((option) => option.value === source)}
                        onChange={(value: ValueType<ReservationSourceOption, false>) => {
                          const nextSource =
                            (value?.value as AssignableReservationSource) || ReservationSource.CX;
                          const nextChannelOptions = reservationChannelOptionsBySource[nextSource];
                          setSource(nextSource);
                          setSelectedChannel(nextChannelOptions[0].value);
                        }}
                      />
                      Select Channel
                      <Select
                        className="mb-3"
                        options={reservationChannelOptionsBySource[source]}
                        value={reservationChannelOptionsBySource[source].find(
                          (option) => option.value === selectedChannel
                        )}
                        onChange={(
                          value: ValueType<{ value: ReservationChannel; label: string }, false>
                        ) => {
                          setSelectedChannel(value?.value || ReservationChannel.BIRDNEST);
                        }}
                      />
                      {typeOfStay === ReservationTypeOfStay.CORPORATES && (
                        <>
                          Company Name
                          <Select
                            className="mb-3"
                            options={
                              companiesList.map((company) => ({
                                value: company.id || '',
                                label: company.name || ''
                              })) as unknown as any
                            }
                            value={
                              companyId
                                ? ({
                                    value: companyId,
                                    label:
                                      companiesList.find((company) => company.id === companyId)
                                        ?.name || ''
                                  } as any)
                                : null
                            }
                            onChange={(
                              value: ValueType<{ value: string | undefined; label: string }, false>
                            ) => {
                              const selectedId = (value?.value || '') as string;
                              setCompanyId(selectedId);
                            }}
                            placeholder="Select company"
                            isClearable={true}
                          />
                        </>
                      )}
                      {typeOfStay === ReservationTypeOfStay.BROKER && (
                        <>
                          Broker
                          <Select
                            className="mb-3"
                            options={brokerOptions}
                            value={
                              brokerOptions.find((option) => option.value === brokerId) || null
                            }
                            onChange={(value: ValueType<BrokerOption, false>) => {
                              setBrokerId(value?.value);
                            }}
                            placeholder="Select broker"
                            isClearable={true}
                            isLoading={isBrokersLoading}
                            isDisabled={isBrokersLoading}
                            noOptionsMessage={() =>
                              isBrokersLoading ? 'Loading brokers...' : 'No brokers found'
                            }
                          />
                        </>
                      )}
                      {isCxSource && (
                        <>
                          Marketing Channel
                          <Select
                            className="mb-3"
                            options={marketingChannelOptions}
                            value={
                              marketingChannelOptions.find(
                                (option) => option.value === marketingChannel
                              ) || null
                            }
                            onChange={(
                              value: ValueType<{ value: MarketingChannel; label: string }, false>
                            ) => {
                              setMarketingChannel(value?.value);
                            }}
                            placeholder="Where did the guest come from?"
                            isClearable={true}
                          />
                          Messaging Channel
                          <Select
                            className="mb-3"
                            options={messagingChannelOptions}
                            value={
                              messagingChannelOptions.find(
                                (option) => option.value === messagingChannel
                              ) || null
                            }
                            onChange={(
                              value: ValueType<{ value: MessagingChannel; label: string }, false>
                            ) => {
                              setMessagingChannel(value?.value);
                            }}
                            placeholder="How did the guest reach us?"
                            isClearable={true}
                          />
                        </>
                      )}
                      <div>
                        <FormControlLabel
                          control={
                            <Checkbox
                              checked={isRelatedReservation}
                              onChange={(event: React.ChangeEvent<HTMLInputElement>) => {
                                const checked = event.target.checked;
                                setIsRelatedReservation(checked);
                                if (!checked) setRelatedReservationId('');
                              }}
                              style={{ color: '#237c58' }}
                              inputProps={{ 'aria-label': 'related reservation toggle' }}
                            />
                          }
                          label="This reservation is linked to another reservation"
                        />
                        {isRelatedReservation && (
                          <div className="mb-3">
                            <span className="block mb-1">Related reservation number</span>
                            <InputText
                              data={{
                                value: relatedReservationId,
                                placeholder: 'Enter reservation number',
                                errorMessage: 'Reservation number is required'
                              }}
                              config={{
                                autoFocus: false,
                                maxRows: 1,
                                type: InputTextType.number,
                                required: true
                              }}
                              eventHandlers={{
                                onChangeHandler: (value: string) => setRelatedReservationId(value)
                              }}
                            />
                          </div>
                        )}
                      </div>
                      Sales Person
                      <Select
                        className="mb-3"
                        menuPortalTarget={document.body}
                        menuPosition="fixed"
                        styles={{ menuPortal: (base: any) => ({ ...base, zIndex: 9999 }) }}
                        options={salesPersons.map((item) => ({
                          value: item.id || '',
                          label: item.name || item.email || item.phone || 'Unnamed sales person',
                          salesPerson: item
                        }))}
                        value={
                          salesPerson
                            ? ({
                                value: salesPerson.id || '',
                                label:
                                  salesPerson.name ||
                                  salesPerson.email ||
                                  salesPerson.phone ||
                                  'Unnamed sales person',
                                salesPerson
                              } as SalesPersonOption)
                            : null
                        }
                        onChange={(value: ValueType<SalesPersonOption, false>) => {
                          setSalesPerson(value?.salesPerson || null);
                        }}
                        placeholder="Select sales person"
                        isClearable={true}
                        isLoading={isSalesPersonsLoading}
                        isDisabled={isSalesPersonsLoading}
                        noOptionsMessage={() =>
                          isSalesPersonsLoading
                            ? 'Loading sales persons...'
                            : 'No sales persons found'
                        }
                      />
                      {guestDetails && (
                        <>
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={skipEmail}
                                onChange={handleSkipEmailChange}
                                style={{ color: '#237c58' }}
                                inputProps={{ 'aria-label': 'primary checkbox' }}
                              />
                            }
                            label="Do Not Send Confirmation Email To Guest"
                          />
                          <FormControlLabel
                            control={
                              <GreenSwitch
                                checked={isComplimentary}
                                onChange={(event) => setIsComplimentary(event.target.checked)}
                              />
                            }
                            label="Complimentary"
                          />
                          {/* <FormControlLabel
                            control={
                              <Checkbox
                                checked={skipPaymentEmail}
                                onChange={handleSkipPaymentEmailChange}
                                style={{ color: '#237c58' }}
                                inputProps={{ 'aria-label': 'primary checkbox' }}
                              />
                            }
                            label="Do Not Send Payment Links To The Guest"
                          /> */}
                        </>
                      )}
                    </>
                  )}
                  <div className="mt-4">
                    <ReCAPTCHA ref={recaptchaRef} size="invisible" sitekey={captchaKEy || ''} />
                  </div>
                </div>
              )}
            </div>
            <div>
              {bookoffer && selectedUnitType && selectedDates && isCreateReservation && (
                <PaymentDetails
                  data={{
                    bookOffer: bookoffer,
                    unitType: selectedUnitType,
                    checkInDate: selectedDates[0],
                    checkOutDate: selectedDates[1],
                    guestDetails
                  }}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </Modal>
  );
};

export default connect((state: RootState) => ({ userId: state.auth.userId }))(
  ReservationsCreateContainer
);

const getDaysArray = (s: any, e: any) => {
  const a: Date[] = [];
  for (const d = new Date(s); d <= e; d.setDate(d.getDate() + 1)) {
    a.push(new Date(d));
  }
  return a;
};
